exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-status[data-v-fabd3d88]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:48px 0 20px}.back-order[data-v-fabd3d88]{margin-left:.8em;font-weight:400;font-size:12px;line-height:1;-ms-flex-item-align:center;align-self:center;color:#0884f3;cursor:pointer}", ""]);

// exports
